import { Box, Button, Typography } from "@mui/material";
import Iconify from "../../components/iconify/Iconify";

function EmptyCategoryItems({ onClearSearch }) {
  //   return (
  //     <Box
  //       sx={{
  //         textAlign: "center",
  //         py: 6,
  //         px: 2,
  //         color: "text.secondary",
  //       }}
  //     >
  //       <Iconify
  //         icon="mdi:food-off-outline"
  //         width={60}
  //         height={60}
  //         style={{ opacity: 0.5 }}
  //       />
  //       <Typography variant="h6" sx={{ mt: 2 }}>
  //         No Items Found
  //       </Typography>
  //       <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
  //         Select another category or add new items to this category.
  //       </Typography>
  //     </Box>
  //   );
  return (
    <Box
      sx={{
        textAlign: "center",
        py: 6,
        px: 2,
        color: "text.secondary",
      }}
    >
      <Iconify
        icon="mdi:magnify-close"
        width={60}
        height={60}
        style={{ opacity: 0.5 }}
      />
      <Typography variant="h6" sx={{ mt: 2 }}>
        No Results Found
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        Try adjusting your search or clear the filter to see all items.
      </Typography>

      <Button
        variant="outlined"
        size="small"
        onClick={onClearSearch}
        startIcon={<Iconify icon="mdi:close-circle-outline" />}
        sx={{ mt: 3 }}
      >
        Clear Search
      </Button>
    </Box>
  );
}

export default EmptyCategoryItems;
